import React, { useMemo } from 'react'
import { css } from '@emotion/react'
import { string } from 'prop-types'
import { CAMPAIGNS } from '@/constants'
import { filterAppsForLicense } from '@/utils/products'
import useCampaigns from '@/hooks/useCampaigns'
import mediaQueries from '@/layout/media-queries'
import ProductCard from '@/components/Product/Card'

const rowCss = (appsLength) => css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  margin-left: -16px;
  margin-right: -16px;

  margin-bottom: 20px;

  ${mediaQueries.smallScreen()} {
    margin-bottom: 30px;
  }

  ${mediaQueries.xlargeScreen()} {
    margin-left: -20px;
    margin-right: -20px;
  }

  .item-card-base {
    ${mediaQueries.xlargeScreen()} {
      width: calc(25% - 40px);
      margin: 0 20px 40px 20px;
    }

    ${appsLength % 2 !== 0
      ? `
      ${mediaQueries.smallScreen()} {
        &:last-child {
          display: none;
        }
      }

      ${mediaQueries.largeScreen()} {
        &:last-child {
          display: flex;
        }
      }

      ${mediaQueries.xlargeScreen()} {      
        &:last-child {
          display: none;
        }
      }`
      : ''}
  }
`

const sectionTitleCss = css`
  margin-top: 0;
  margin-bottom: 32px;

  ${mediaQueries.xlargeScreen()} {
    margin-bottom: 40px;
  }
`

const getCampaignApps = (campaigns) => {
  const campaignApps = campaigns
    .filter(
      (campaign) =>
        !campaign.attributes.tags.includes([
          CAMPAIGNS.TAGS.APP_OF_THE_WEEK,
          CAMPAIGNS.TAGS.APP_OF_THE_MONTH,
          CAMPAIGNS.TAGS.APP_OF_THE_MONTH_RIGHT,
        ])
    )
    .reduce((apps, { applications = [] }) => {
      for (const application of applications) {
        if (!apps.has(application.id)) {
          apps.set(application.id, application)
        }
      }

      return apps
    }, new Map())

  return filterAppsForLicense(Array.from(campaignApps.values())).slice(0, 9)
}

const AppsList = ({ className }) => {
  const { allCampaigns } = useCampaigns()
  const pickedApps = useMemo(
    () => getCampaignApps(allCampaigns),
    [allCampaigns]
  )

  return (
    <section className={className}>
      <h5 css={sectionTitleCss}>Here are some apps you may like</h5>
      <div css={rowCss(pickedApps.length)}>
        {pickedApps.map((app) => (
          <ProductCard app={app} key={app.id} />
        ))}
      </div>
    </section>
  )
}

AppsList.propTypes = {
  className: string,
}

export default AppsList
